import classNames from "classnames/bind";
import { Fragment } from "react";
import { Icon, Placeholder, PlaceholderLine, PlaceholderParagraph } from "semantic-ui-react";
import styles from "./CardMeta.module.scss";

interface Props {
  stretch?: boolean;
  stacked?: boolean;
  light?: boolean;
  children?: React.ReactNode;
  extra?: React.ReactNode;
  loading?: boolean;
  className?: string;
}

const IconSpacer = () => (
  <span className={styles.iconContainer} data-testid="spacer">
    <Icon name="circle" size="mini" fitted />
  </span>
);

export const CardMeta: React.FC<Props> = ({ children, stretch, stacked, light, extra, loading, className }) => {
  const cx = classNames.bind(styles);

  const getPlaceholder = () => (
    <Placeholder>
      <PlaceholderParagraph>
        <PlaceholderLine />
      </PlaceholderParagraph>
    </Placeholder>
  );

  const getContent = () =>
    Array.isArray(children)
      ? children.map((child, idx) => {
          // Need to have a spacing circle after all elements (except final)
          return (
            <Fragment key={idx}>
              {child}
              {idx !== children.length - 1 ? <IconSpacer /> : null}
            </Fragment>
          );
        })
      : children;

  return (
    <div
      className={cx("root", className, {
        stacked: stacked,
      })}
    >
      <div
        className={cx("meta", {
          stretch: stretch,
          light: light,
        })}
      >
        {loading ? <div className={cx("placeholder")}>{getPlaceholder()}</div> : getContent()}
      </div>
      <div className={cx("extra")}>{loading ? <div className={cx("placeholder")}>{getPlaceholder()}</div> : extra}</div>
    </div>
  );
};
